/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-18 11:41:56
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-04-25 15:17:18
 * @FilePath: /unifyxp-v2-store-portal/src/config/SiderConfig/SalesChannelProductSiderConfig.tsx
 */

import React, { useState, useEffect } from 'react';
import { get } from 'lodash';
import { Icon } from '@/src/tools/icon';
import NameWithErr from 'src/constrains/SiderErrorController/SiderNameWithErr';
import { EnumSider, EnumSiderEvent } from 'src/types/common/sider';
import { updateSalesChannelProduct } from 'src/constrains/SiderErrorController/tools';
import { salesChannelDict } from 'src/tools/urlMap';
import { getI18nFromGeneral } from 'src/tools/tools';
import { useDispatch, useSelector } from 'react-redux';
import { currentSelectedLanguage } from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import {
  clearProductDetail,
  fetchSalesChannelProductDetail,
  selectProductDetailData,
} from './slice/SalesChannelProductSiderConfigSlice';
import { AppDispatch } from 'src/store';

export const menuArray = ({ saleChannelUuid, salesChannelProductUuid }) => {
  const [showCustomisation, setShowCustomisation] = useState(true);
  const dispatch = useDispatch<AppDispatch>();
  const language = useSelector(currentSelectedLanguage());
  const productDetailData = useSelector(selectProductDetailData);

  useEffect(() => {
    if (saleChannelUuid) {
      dispatch(
        fetchSalesChannelProductDetail({
          saleChannelUuid,
          forceUpdate: true,
          currentLanguage: language,
          ...(salesChannelProductUuid &&
            salesChannelProductUuid !== 'null' && {
              salesChannelProductUuid,
            }),
        }),
      );
    }
    updateSalesChannelProduct({
      uuid: saleChannelUuid,
      productUuid: salesChannelProductUuid,
      forceUpdate: true,
    });
    return () => {
      dispatch(clearProductDetail());
    };
  }, [dispatch, saleChannelUuid, salesChannelProductUuid, language]);

  useEffect(() => {
    // Check if data exists and has the products property before accessing it
    if (productDetailData && productDetailData.products) {
      const { products } = productDetailData;
      const isVirtual = ['Service', 'GiftCard'].includes(
        get((products || [])[0], 'productType'),
      );
      setShowCustomisation(!isVirtual);
    }
  }, [productDetailData]);

  useEffect(() => {
    const _update = () => {
      // Force update the store data and the general info
      if (saleChannelUuid) {
        dispatch(
          fetchSalesChannelProductDetail({
            saleChannelUuid,
            forceUpdate: true,
            currentLanguage: language,
            ...(salesChannelProductUuid &&
              salesChannelProductUuid !== 'null' && {
                salesChannelProductUuid,
              }),
          }),
        );
      }
      updateSalesChannelProduct({
        uuid: saleChannelUuid,
        productUuid: salesChannelProductUuid,
        forceUpdate: true,
      });
    };

    window.removeEventListener(EnumSiderEvent.salesChannelProduct, _update);
    window.addEventListener(EnumSiderEvent.salesChannelProduct, _update);

    return () => {
      window.removeEventListener(EnumSiderEvent.salesChannelProduct, _update);
    };
  }, [dispatch, saleChannelUuid, salesChannelProductUuid, language]);

  const _name = (name) => [salesChannelProductUuid, name];
  const arr = !showCustomisation
    ? [
        {
          path: `/salesChannel/products/link/${saleChannelUuid}/${salesChannelProductUuid}`,
          iconType: <Icon type='iconlink' style={iconStyle} />,
          name: (
            <NameWithErr
              name={getI18nFromGeneral('general.sider.linkProduct')}
              id={_name(EnumSider.SalesChannelProductLinkProduct)}
            />
          ),
          key: 'salesChannelProductsLink',
          routers: salesChannelDict.product, //['/salesChannel/products/link/*/*'],
        },
        {
          path: `/salesChannel/products/content/${saleChannelUuid}/${salesChannelProductUuid}`,
          iconType: <Icon type='iconcontent1' style={iconStyle} />,

          name: (
            <NameWithErr
              name={getI18nFromGeneral('general.sider.content')}
              id={_name(EnumSider.SalesChannelProductContent)}
            />
          ),
          key: 'salesChannelProductsContent',
          routers: salesChannelDict.productContent, //['/salesChannel/products/content/*/*'],
        },
        {
          path: `/salesChannel/products/alias/${saleChannelUuid}/${salesChannelProductUuid}`,
          iconType: <Icon type='iconproductsalias1' style={iconStyle} />,
          name: (
            <NameWithErr
              name={getI18nFromGeneral('general.sider.alias')}
              id={_name(EnumSider.SalesChannelProductAlias)}
            />
          ),
          key: 'salesChannelProductsAlias',
          routers: salesChannelDict.productAlias, //
          // [
          //   '/salesChannel/products/alias/*/*',
          //   '/salesChannel/products/alias/*/*/*',
          // ],
        },
      ]
    : [
        {
          path: `/salesChannel/products/link/${saleChannelUuid}/${salesChannelProductUuid}`,
          iconType: <Icon type='iconlink' style={iconStyle} />,
          name: (
            <NameWithErr
              name={getI18nFromGeneral('general.sider.linkProduct')}
              id={_name(EnumSider.SalesChannelProductLinkProduct)}
            />
          ),
          key: 'salesChannelProductsLink',
          routers: salesChannelDict.product, //['/salesChannel/products/link/*/*'],
        },
        {
          path: `/salesChannel/products/content/${saleChannelUuid}/${salesChannelProductUuid}`,
          iconType: <Icon type='iconcontent1' style={iconStyle} />,

          name: (
            <NameWithErr
              name={getI18nFromGeneral('general.sider.content')}
              id={_name(EnumSider.SalesChannelProductContent)}
            />
          ),
          key: 'salesChannelProductsContent',
          routers: salesChannelDict.productContent, //['/salesChannel/products/content/*/*'],
        },
        {
          path: `/salesChannel/products/alias/${saleChannelUuid}/${salesChannelProductUuid}`,
          iconType: <Icon type='iconproductsalias1' style={iconStyle} />,
          name: (
            <NameWithErr
              name={getI18nFromGeneral('general.sider.alias')}
              id={_name(EnumSider.SalesChannelProductAlias)}
            />
          ),
          key: 'salesChannelProductsAlias',
          routers: salesChannelDict.productAlias, //
          // [
          //   '/salesChannel/products/alias/*/*',
          //   '/salesChannel/products/alias/*/*/*',
          // ],
        },
        {
          path: `/salesChannel/products/customisation/${saleChannelUuid}/${salesChannelProductUuid}`,
          iconType: <Icon type='iconcustomization' style={iconStyle} />,
          name: getI18nFromGeneral('general.sider.customisation'),
          key: 'salesChannelProductsCustomisation',
          routers: salesChannelDict.productCustomization, //['/salesChannel/products/customisation/*/*'],
        },
      ];
  return arr;
};

const iconStyle = {
  //color: 'inherit',
  heihgt: '24px',
  width: '24px',
  fontSize: '24px',
};
